import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavLink,
  NavItem,
} from "reactstrap";
// @ts-ignore
import logo from "../../assets/logo-white.png";
import { useTranslation } from "react-i18next";

interface NavItemProps {
  title: string;
  link?: string;
}
const NAVITEM = (props: NavItemProps) => {
  const { title, link = "/" } = props;
  return (
    <Link to={link} className="mx-auto cursor-pointer hover:text-gray-400">
      {title}
    </Link>
  );
};

const NAVBAR = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const toggle = () => setIsOpen(!isOpen);
  return (
    <div className="w-full flex flex-col">
      {/* Larger Grids */}
      <section className="hidden lg:flex w-full flex-col items-center">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
        <div className=" py-3 w-full border-[0.5px] !border-gray-500 flex justify-center font-bold text-center text-[0.8rem] lg:text-[1rem]">
          <div className="w-full md:w-[60%] lg:w-[30%] flex">
            <NAVITEM title="Casinos" link="casinos" />
            <NAVITEM title={t("sportsbetting")} link="sports-betting" />
            <NAVITEM title="Bonus" link="bonuses" />
            <NAVITEM title={t("games")} link="games" />
          </div>
        </div>
      </section>
      {/* Smaller Grids */}
      <section className="lg:hidden">
        <Navbar className="w-full sticky-top" dark>
          <NavbarBrand href="/">
            <img
              src={logo}
              alt="Casino24"
              className="object-cover w-[10rem] lg:hidden"
            />
          </NavbarBrand>
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar>
            <Nav className="me-auto" navbar>
              <NavItem>
                <NavLink href="casinos">Casinos</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="sportsbetting">Sportwetten</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="bonuses">Bonus</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="games">Spiele</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </section>
    </div>
  );
};

export default NAVBAR;
